// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".marquee img {\n  height: 30vh;\n  width: 30vh;\n  object-fit: cover;\n  padding: 1rem;\n}\n", "",{"version":3,"sources":["webpack://src/css/marquesina.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf","sourcesContent":[".marquee img {\n  height: 30vh;\n  width: 30vh;\n  object-fit: cover;\n  padding: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
